import React, { useContext, useEffect, useState } from "react";
import PhotoVaultPhotosItems from "./PhotoVaultPhotosItems";
import { Link, useParams } from "react-router-dom";
import PhotoVaultSingleVaultItem from "./PhotoVaultSingleVaultItem";
import { AuthContext } from "../../../../context/App-Context";
import axios from "axios";

import { FaTrashAlt } from "react-icons/fa";
import { FcEmptyTrash } from "react-icons/fc";
import { PiTrashSimpleThin } from "react-icons/pi";
import PhotoVaultPictureAddForm from "../formzs/PhotoVaultPictureAddForm";

const PhotoVaultPhotos = () => {
  /////// photos , background white

  const auth = useContext(AuthContext);
  const [activeUploadAlbum, setActiveUploadAlbum] = useState(null);
  const handleStartUpload = (albumName) => {
    setActiveUploadAlbum(albumName);
  };

  const [expandedAlbumIndex, setExpandedAlbumIndex] = useState(null);
  // const { UsernameUserID } = useParams();

  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      // console.log("starting");
      try {
        //setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/u-ablts/getPhotosInPhotoVault/${auth.loginVar}`
        ); // Example API endpoint
        // console.log(response.data.data[0]);
        // console.log(response.data.data[0].username);
        setData(response.data.data);
        // console.log(response.data.data);
        // console.log(response.data.data.templeGrid_PhotoVault);
      } catch (err) {
        // setError(err.message);
      } finally {
        // setLoading(false);
      }
    };
    fetchData();
    //console.log(auth.loginVar);
  }, [auth.loginVar]);

  /////// use effect for now

  ///// then to state func

  if (process.env.REACT_APP_BACKEND_URL === `http://localhost:5000/api`) {
    //console.log(auth);
  }

  ////////////////////////////////
  ///// submit

  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(""); // feedback to user
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Don't submit empty form
    if (!message.trim()) {
      setStatus("Please enter something");
      return;
    }

    setLoading(true);
    setStatus("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/u-ablts/createPhotoVault`, // ← replace with your real endpoint
        {
          templeGridNormalPostData: {
            photoAlbumName: message,
            photosInVault: [],
          },
          userUsername: auth.loginVar,
          // you can add more fields here: userId, timestamp, etc.
        },
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`,  // if needed
          },
        }
      );

      // Success
      setStatus("PhotoVault created...");
      setMessage(""); // clear input

      // console.log("Server response:", response.data);
    } catch (error) {
      console.error("Submission error:", error);

      // Better error messages for user
      if (error.response) {
        // Server responded with error status (4xx, 5xx)
        setStatus(
          error.response.data?.message || `Error: ${error.response.status}`
        );
      } else if (error.request) {
        // No response received (network issue, CORS, etc.)
        setStatus("No response from server. Check your connection.");
      } else {
        setStatus("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }

    const fetchData = async () => {
      //console.log("starting");
      try {
        //setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/u-ablts/getPhotosInPhotoVault/${auth.loginVar}`
        ); // Example API endpoint
        // console.log(response.data.data[0]);
        // console.log(response.data.data[0].username);
        setData(response.data.data);
        // console.log(response.data.data);
        // console.log(response.data.data.templeGrid_PhotoVault);
      } catch (err) {
        // setError(err.message);
      } finally {
        // setLoading(false);
      }
    };
    fetchData();
  };

  const toggleAlbum = (index) => {
    setExpandedAlbumIndex(
      (prev) => (prev === index ? null : index) // close if already open
    );
  };

  /////// delete album

  const handleDeleteAlbum = async (index, albumName) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete "${albumName}"?\nThis cannot be undone.`
    );

    if (!confirmDelete) return;

    try {
      // console.log("initiating delete vvv");
      // console.log(index, albumName);
      // Adjust endpoint to match your backend route
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/u-ablts/deletePhotoVaultAlbum/${auth.loginVar}/${albumName}/${index}`
      );

      if (response.status === 200 || response.status === 204) {
        // Optimistic update: remove from local state
        setData((prev) => {
          if (!prev) return prev;
          const updatedVaults = prev.templeGrid_PhotoVault.filter(
            (_, i) => i !== index
          );
          return {
            ...prev,
            templeGrid_PhotoVault: updatedVaults,
          };
        });

        alert("Album deleted successfully");
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert(
        error.response?.data?.message ||
          "Failed to delete album. Please try again."
      );
    }

    const fetchData = async () => {
      //console.log("starting");
      try {
        //setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/u-ablts/getPhotosInPhotoVault/${auth.loginVar}`
        ); // Example API endpoint
        // console.log(response.data.data[0]);
        // console.log(response.data.data[0].username);
        setData(response.data.data);
        // console.log(response.data.data);
        // console.log(response.data.data.templeGrid_PhotoVault);
      } catch (err) {
        // setError(err.message);
      } finally {
        // setLoading(false);
      }
    };
    fetchData();
  };

  ////////// delete album

  //////////// submit

  //////////////////////////// state

  /////// div > < album div , return state > < / div

  return (
    // <div>
    <div className="templegrid">
      <div className="templegrid-courtyard-setting"></div>
      {/* <div>backsplash , with cute white arrow</div>
      photos , lined up */}

      <div>
        <div
          style={{ maxWidth: "480px", margin: "2rem auto", padding: "1.5rem" }}
        >
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "1rem" }}>
              <label
                htmlFor="message"
                style={{ display: "block", marginBottom: "0.5rem" }}
              ></label>

              <input
                id="message"
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="PhotoVault..."
                disabled={loading}
                style={{
                  width: "100%",
                  padding: "0.75rem",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  fontSize: "1rem",
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading || !message.trim()}
              style={{
                padding: "0.75rem 1.5rem",
                backgroundColor: loading ? "#aaa" : "#0066cc",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: loading ? "not-allowed" : "pointer",
                fontSize: "1rem",
              }}
            >
              {loading ? "Posting..." : "New Vault"}
            </button>
          </form>

          {status && (
            <p
              style={{
                marginTop: "1rem",
                padding: "0.75rem",
                borderRadius: "6px",
                backgroundColor: status.includes("success")
                  ? "#e6ffe6"
                  : "#ffe6e6",
                color: status.includes("success") ? "#006600" : "#cc0000",
              }}
            >
              {status}
            </p>
          )}
        </div>
      </div>
      {/* <div>
        {data &&
          data.templeGrid_PhotoVault.map((photoVaultData, index) => (
            // <Link to={`/TempleGrid/photovault/album`}>

            /////////
            /////////////// if index clicked , add state , full ccs

            <div>
              <div>
                this is trash *
                <button
                  onClick={() =>
                    handleDeleteAlbum(index, photoVaultData.photoAlbumName)
                  }
                  className="trash-btn"
                  title="Delete this album"
                  aria-label={`Delete album ${photoVaultData.photoAlbumName}`}
                >
                  <PiTrashSimpleThin size={18} />
                </button>
              </div>
              <PhotoVaultSingleVaultItem
                photoAlbumName={photoVaultData.photoAlbumName}
              />

              {/* <PhotoVaultPhotosItems
                photoAlbumActivateVision
                photoVaultAlbumIndex={index}
                photoAlbumName={photoVaultData.photoAlbumName}
                photoAlbum={photoVaultData.photosInVault}
              /> 

{isExpanded && (
                <div style={{ padding: "1rem" }}>
                  <PhotoVaultPhotosItems
                    photoAlbumActivateVision={true} // or whatever this prop does
                    photoVaultAlbumIndex={index}
                    photoAlbumName={photoVaultData.photoAlbumName}
                    photoAlbum={photoVaultData.photosInVault}
                  />
                </div>
              )}
            </div>
          ))}
      </div> */}

      <div style={{ padding: "1rem" }}>
        {data?.templeGrid_PhotoVault?.map((vault, index) => {
          const isExpanded = expandedAlbumIndex === index;

          return (
            <div
              key={vault.photoAlbumName} // better key if name can change
              style={{
                marginBottom: "1.5rem",
                border: "1px solid #ddd",
                borderRadius: "8px",
                overflow: "hidden",
                backgroundColor: "#fff",
              }}
            >
              {/* Clickable album header */}
              <div
                onClick={() => toggleAlbum(index)}
                style={{
                  padding: "1rem",
                  backgroundColor: isExpanded ? "#f0f8ff" : "#fafafa",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <PhotoVaultSingleVaultItem
                  photoAlbumName={vault.photoAlbumName}
                />

                <div
                  style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                >
                  <button
                    onClick={(e) => {
                      e.stopPropagation(); // prevent toggling album when clicking delete
                      handleDeleteAlbum(index, vault.photoAlbumName);
                    }}
                    title="Delete album"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    <PiTrashSimpleThin size={20} color="#e74c3c" />
                  </button>
                  <span>{isExpanded ? "▲" : "▼"}</span>
                </div>
              </div>

              {/* Photos only render when expanded */}
              {isExpanded && (
                <div style={{ padding: "1rem" }}>
                  <PhotoVaultPictureAddForm
                    photoVaultAlbumIndex={index}
                    photoVaultAlbumName={vault.photoAlbumName}
                  />
                  <PhotoVaultPhotosItems
                    photoAlbumActivateVision={true} // or whatever this prop does
                    photoVaultAlbumIndex={index}
                    photoAlbumName={vault.photoAlbumName}
                    photoAlbum={vault.photosInVault}
                  />
                </div>
              )}
            </div>
          );
        })}

        {!data?.templeGrid_PhotoVault?.length && (
          <p style={{ textAlign: "center", color: "#777", marginTop: "2rem" }}>
            No photo vaults yet. Create one above!
          </p>
        )}
      </div>
    </div>
  );
};

export default PhotoVaultPhotos;
